/**
 * Created by jonas on 2021-03-01.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {DasUBootGameMode} from "../server/DasUBootGameMode";
import {DasUBoot} from "../DasUBoot";
import {DasUBootGameAssets} from "../DasUBootGameAssets";
import {SpineGSAPWrapper} from "../../core/animation/SpineGSAPWrapper";
import {DasUBootSound} from "../sound/DasUBootSound";


export enum ModeTransition {
    FREE_SPIN = "FREE_SPIN",
    SUPER_FREE_SPIN = "SUPER_FREE_SPIN",
    MAX_WIN = "MAX_WIN",
}


export enum TextSpriteTexture {
    FREE_SPIN = "transitions/freeSpins",
    SUPER_FREE_SPIN = "transitions/superFreeSpins",
    NONE = "none",
}

export class ModeTransitionScreen extends PIXI.Container implements StageLayer {
    public background:PIXI.Sprite;
    public button:ContinueButton;
    public mainContainer:PIXI.Container;
    private clickCallback:Function;
    private text:PIXI.Text;
    private _spine:PIXI.spine.Spine;
    private colorForModeIntro:Map<ModeTransition, number>;
    private colorForModeOutro:Map<ModeTransition, number>;
    private textSprite:PIXI.Sprite;
    private textTargetScale:number;
    private modeAnimation:gsap.core.Timeline | undefined;

    constructor() {
        super();
        this.init();
    }

    private init() {
        this.name = "ModeTransitionScreen";

        this.colorForModeIntro = new Map([
            [ModeTransition.FREE_SPIN, PIXI.utils.string2hex("#851f1f")],
            [ModeTransition.SUPER_FREE_SPIN, PIXI.utils.string2hex("#214b69")],
            [ModeTransition.MAX_WIN, PIXI.utils.string2hex("#000000")],
        ]);

        this.colorForModeOutro = new Map([
            [ModeTransition.FREE_SPIN, PIXI.utils.string2hex("#1b5a40")],
            [ModeTransition.SUPER_FREE_SPIN, PIXI.utils.string2hex("#1b5a40")],
            [ModeTransition.MAX_WIN, PIXI.utils.string2hex("#000000")],
        ]);


        this.mainContainer = new PIXI.Container();
        this.background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.background.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        this.background.tint = 0;

        this.button = new ContinueButton();
        this.button.addClickCallback(() => this.onButtonClick());

        this.button.position.set(360, 610);
        this.button.pivot.set(this.button.width * 0.5, this.button.height * 0.5);
        this.button.enable(false);
        this.button.alpha = 0;

        this.text = new PIXI.Text("", new PIXI.TextStyle({
            fill:0xffffff,
            dropShadow:true,
            fontFamily:OpenSans.FAMILY,
            fontSize:50,
            fontWeight:FontWeight.EXTRA_BOLD,
            fontStyle:FontStyle.NORMAL
        }));
        this.text.anchor.set(0.5, 0.5);
        this.text.position.set(360, 62);
        this.textTargetScale = 1;

        this.textSprite = new PIXI.Sprite();
        this.textSprite.anchor.set(0.5,0.5);
        this.textSprite.position.set(360, 140);

        this._spine = new PIXI.spine.Spine(DasUBoot.assetLoader.getSpineAsset(DasUBootGameAssets.FS_TRANSITIONS));
        this._spine.position.set(360, 360);
        this._spine.visible = true;

        this.mainContainer.addChild(this.background);
        this.mainContainer.addChild(this._spine);
        this.mainContainer.addChild(this.button);
        this.mainContainer.addChild(this.text);
        this.mainContainer.addChild(this.textSprite);
    }

    public onResize() {
        if (this.mainContainer.visible) {
            this.background.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
            this.background.width = NolimitApplication.screenBounds.width;
            this.background.height = NolimitApplication.screenBounds.height;

            if (NolimitApplication.isLandscape) {
                this.button.position.set(360, 610);
            } else {
                this.button.position.set(360, NolimitApplication.screenBounds.bottom - 200);
            }
        }
    }

    public enableButton(cb:Function) {
        this.clickCallback = cb;
        this.button.enable(true);
        gsap.to(this.button, {duration:0.2, alpha:1});
    }

    private onButtonClick() {
        this.button.enable(false);
        if (this.clickCallback == undefined) {
            throw new Error("No button click callback");
        }
        this.clickCallback();
        DasUBoot.soundPlayer.playSound(DasUBootSound.CONTINUE_BUTTON);
        gsap.to(this.button, {duration:0.2, alpha:0});
    }

    public setText(string:string) {
        this.text.text = string;
        this.text.scale.set(1,1);
        this.textTargetScale = 1;
        if (this.text.width > 700){
            this.text.width = 700;
            this.textTargetScale = this.text.scale.x;
        }

    }
    public setTextSprite(texture:TextSpriteTexture){
        if (texture == TextSpriteTexture.NONE){
            this.textSprite.texture = PIXI.Texture.EMPTY;
        } else {
            this.textSprite.texture = DasUBoot.assetLoader.getTextures(texture)[0];
        }
    }

    public show(mode:ModeTransition, intro:boolean):gsap.core.Timeline {
        const colorMap = intro ? this.colorForModeIntro : this.colorForModeOutro;
        let color = colorMap.get(mode) || 0;

        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.addChild(this.mainContainer);
            this.background.alpha = 0;
            this.background.tint = color;
            this.text.scale.set(0, 0);
            this.textSprite.scale.set(0, 0);
            this.mainContainer.visible = true;
            this.onResize();
            SpineGSAPWrapper.clearAnimation(this._spine, 0);
            this._spine.alpha = mode == ModeTransition.MAX_WIN ? 0 : 1;
        });

        tl.add([
            gsap.to(this.background, {duration:0.5, pixi:{alpha:1}}),
        ]);

        tl.add(() => this.startModeAnimation(mode, intro));

        tl.add([
            gsap.to(this.text, {duration:0.5, pixi:{scale:this.textTargetScale}}),
            gsap.to(this.textSprite, {duration:0.5, pixi:{scale:1}}),
        ]);

        return tl;
    }

    public hide():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add([
            gsap.to(this._spine, {duration:0.5, pixi:{alpha:0}}),
            gsap.to(this.text, {duration:0.5, pixi:{scale:0}}),
            gsap.to(this.textSprite, {duration:0.5, pixi:{scale:0}}),
        ]);
        tl.add([
            gsap.to(this.background, {duration:0.5, pixi:{alpha:0.0}})
        ]);
        tl.add(() => {
            this.mainContainer.visible = false;
            this.removeChild(this.mainContainer);
            SpineGSAPWrapper.clearAnimation(this._spine, 0);
        });
        return tl;
    }


    private startModeAnimation(mode:ModeTransition, intro:boolean) {
        if (this.modeAnimation){
            this.modeAnimation.kill();
        }

        const tl:gsap.core.Timeline = gsap.timeline();

        if (intro) {
            if (mode == ModeTransition.FREE_SPIN) {
                tl.add(SpineGSAPWrapper.createTimeline(this._spine, 0, "FS_intro_start"));
                tl.add(SpineGSAPWrapper.createTimeline(this._spine, 0, "FS_intro_loop",-1));
            }
            if (mode == ModeTransition.SUPER_FREE_SPIN) {
                tl.add(SpineGSAPWrapper.createTimeline(this._spine, 0, "SFS_intro_start"));
                tl.add(SpineGSAPWrapper.createTimeline(this._spine, 0, "SFS_intro_loop", -1));
            }
        } else {
            if (mode == ModeTransition.MAX_WIN){
                tl.add([
                    gsap.to(this._spine, {duration:1, alpha:1}),
                    SpineGSAPWrapper.createTimeline(this._spine, 0, "MaxWinLoop", -1)
                ]);
            }
            else {
                tl.add(SpineGSAPWrapper.createTimeline(this._spine, 0, "FS_outro_start"));
                tl.add(SpineGSAPWrapper.createTimeline(this._spine, 0, "FS_outro_loop", -1));
            }
        }

        tl.add(()=>{
            delete this.modeAnimation;
        })
        this.modeAnimation = tl;

    }
}